import styles from "./index.module.scss";
import intl from "react-intl-universal";
const DetailTitle = ({ title, isrequire }) => {
	return <h2 className={styles.detailTitleBox}>{intl.get(title)}{isrequire && <span>*</span>}</h2>
}
export default DetailTitle
